import InnerBanner from "./InnerBanner";

export default InnerBanner;